module.exports = __webpack_public_path__ + "img/PinadaView.7ea7f19d.jpeg";